/* HEADER JOLIES — JS de comportamiento
   - Estado transparent ↔ opaque (hover, scroll, leave)
   - Mega menu desktop (hover + focus)
   - Mobile drawer (burger)
   - Search overlay mobile
   - Cart trigger (delega en cart-drawer existente del activo)
*/
(function(){
  if (window.__hjInited) return;
  window.__hjInited = true;

  function init() {
    const header = document.querySelector('.hj');
    if (!header) return;

    // Set --ajb-h variable según altura real announcement bar
    function syncAnnHeight() {
      const annBar = document.querySelector('announcement-bar-jolies, .ajb-wrap, .ajb');
      if (annBar) {
        const h = annBar.getBoundingClientRect().height;
        if (h > 0) document.documentElement.style.setProperty('--ajb-h', h + 'px');
      }
    }
    syncAnnHeight();
    window.addEventListener('resize', syncAnnHeight);
    setTimeout(syncAnnHeight, 500);
    setTimeout(syncAnnHeight, 1500);

    // ========== TRANSPARENT MODE ==========
    // El header arranca transparent si está marcado data-default-transparent="true" Y la página no scrolleó
    const defaultTransparent = header.dataset.defaultTransparent === 'true';
    let isHover = false;
    let scrolledPast = false;
    let heroThreshold = 30;

    function updateMode() {
      if (!defaultTransparent) {
        header.classList.remove('hj--transparent');
        header.classList.remove('hj--opaque');
        header.classList.remove('hj--scrolled');
        return;
      }
      header.classList.add('hj--transparent');
      const opaque = isHover || scrolledPast;
      header.classList.toggle('hj--opaque', opaque);
      header.classList.toggle('hj--scrolled', scrolledPast);
    }

    header.addEventListener('mouseenter', () => { isHover = true; updateMode(); });
    header.addEventListener('mouseleave', () => { isHover = false; updateMode(); });

    function onScroll() {
      const sy = window.scrollY || window.pageYOffset || 0;
      const past = sy > heroThreshold;
      if (past !== scrolledPast) { scrolledPast = past; updateMode(); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    updateMode();

    // ========== MEGA MENU desktop ==========
    header.querySelectorAll('.hj__nav-item.has-mega').forEach(item => {
      const link = item.querySelector('.hj__nav-link');
      if (link) {
        link.addEventListener('click', (e) => {
          // Si el link tiene href real y el viewport es desktop, dejamos navegar
          if (window.innerWidth < 991) return;
          // En desktop, abrir mega al click sin navegar si href = '#'
          if (link.getAttribute('href') === '#') {
            e.preventDefault();
            item.classList.toggle('is-open');
          }
        });
      }
      // Cerrar al click fuera
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.hj__nav-item')) {
        header.querySelectorAll('.hj__nav-item.is-open').forEach(i => i.classList.remove('is-open'));
      }
    });

    // ========== MOBILE DRAWER (con scroll lock robust iOS-compatible) ==========
    const drawer = document.querySelector('.hj-drawer');
    const drawerOverlay = document.querySelector('.hj-drawer__overlay');
    const burger = header.querySelector('.hj__burger');
    let savedScrollY = 0;

    function lockBodyScroll() {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.style.position = 'fixed';
      document.documentElement.style.top = '-' + savedScrollY + 'px';
      document.documentElement.style.left = '0';
      document.documentElement.style.right = '0';
      document.documentElement.style.width = '100%';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }
    function unlockBodyScroll() {
      document.documentElement.style.position = '';
      document.documentElement.style.top = '';
      document.documentElement.style.left = '';
      document.documentElement.style.right = '';
      document.documentElement.style.width = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, savedScrollY);
    }

    function openDrawer() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'false');
      if (drawerOverlay) drawerOverlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hj-drawer-open');
      lockBodyScroll();
      if (burger) burger.setAttribute('aria-expanded', 'true');
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'true');
      if (drawerOverlay) drawerOverlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hj-drawer-open');
      unlockBodyScroll();
      if (burger) burger.setAttribute('aria-expanded', 'false');
    }
    if (burger) burger.addEventListener('click', openDrawer);
    if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);
    document.querySelectorAll('.hj-drawer__close').forEach(b => b.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

    // ========== SEARCH MOBILE OVERLAY ==========
    const searchOverlay = document.querySelector('.hj-search-overlay');
    const searchTrigger = header.querySelector('.hj__search-mobile-icon');
    function openSearch() {
      if (!searchOverlay) return;
      searchOverlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hj-search-open');
      lockBodyScroll();
      const inp = searchOverlay.querySelector('input[type="text"]');
      if (inp) setTimeout(() => inp.focus(), 50);
    }
    function closeSearch() {
      if (!searchOverlay) return;
      searchOverlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hj-search-open');
      unlockBodyScroll();
    }
    // FIX: en movil un flick que empieza sobre el icono puede acabar en "click"
    // sintetico y abrir el buscador sin que el usuario quisiera. Slop de 12px:
    // si el dedo se ha movido, era un scroll, no un tap.
    document.querySelectorAll('.hj__search-mobile-icon').forEach(t => {
      let sx = 0, sy = 0, moved = false;
      t.addEventListener('touchstart', (e) => {
        const p = e.touches && e.touches[0];
        if (!p) return;
        sx = p.clientX; sy = p.clientY; moved = false;
      }, { passive: true });
      t.addEventListener('touchmove', (e) => {
        const p = e.touches && e.touches[0];
        if (!p) return;
        if (Math.abs(p.clientX - sx) > 12 || Math.abs(p.clientY - sy) > 12) moved = true;
      }, { passive: true });
      t.addEventListener('click', (e) => {
        e.preventDefault();
        if (moved) { moved = false; return; }
        openSearch();
      });
    });
    document.querySelectorAll('.hj-search-overlay__close').forEach(b => b.addEventListener('click', closeSearch));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSearch(); });

    // ========== CART TRIGGER ==========
    // El icono cart abre el cart-drawer existente del activo (Dawn pattern)

    // ========== SLIDESHOW: re-trigger entrance + sync progress ==========
    initSlideshowSync();

    // ========== MEGA MENU TOP: medir bottom de .hj y propagar a CSS var ==========
    initMegaMenuPosition();

    // ========== PREDICTIVE SEARCH ==========
    initPredictiveSearch();
  }

  function initPredictiveSearch() {
    const overlay = document.querySelector('[data-hj-search]');
    const input = document.querySelector('[data-hj-search-input]');
    const results = document.querySelector('[data-hj-search-results]');
    const emptyState = document.querySelector('[data-hj-search-empty]');
    const content = document.querySelector('.hj-search-content');
    const noResults = document.querySelector('.hj-search-noresults');
    const collectionsEl = document.querySelector('[data-hj-search-collections]');
    const productsEl = document.querySelector('[data-hj-search-products]');
    const viewAllEl = document.querySelector('[data-hj-search-viewall]');
    const queryEl = document.querySelector('[data-hj-search-query]');
    if (!overlay || !input) return;

    // Desktop: clicking inline search input opens the same overlay
    // FIX: este input vive en .hj__search-inline (display:none en movil) y abria el
    // overlay SIN bloquear el scroll -> panel pegado arriba mientras la pagina seguia
    // deslizandose. Se limita a desktop, que es donde ese input existe de verdad.
    const isDesktopSearch = () => window.innerWidth >= 991;
    document.querySelectorAll('[data-hj-search-trigger-input]').forEach((trigger) => {
      const openInline = () => {
        if (!isDesktopSearch()) return;
        overlay.setAttribute('aria-hidden','false');
        document.body.classList.add('hj-search-open');
        setTimeout(() => input.focus(), 200);
      };
      trigger.addEventListener('click', (e) => {
        if (!isDesktopSearch()) return;
        e.preventDefault();
        openInline();
      });
      trigger.addEventListener('focus', openInline);
    });

    let debounceTimer = null;
    let lastReqId = 0;
    const escapeHTML = (s) => String(s||'').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const formatMoney = (val) => {
      // Predictive search API returns prices as decimal strings (e.g. "39.90", "1199.00")
      // ALWAYS in major currency unit, never cents. Do NOT divide by 100.
      let v = parseFloat(val);
      if (isNaN(v) || v <= 0) return '';
      const c = window.WAB_CURRENCY || {};
      const thou = c.useComma ? '.' : ',';   // miles
      const decSep = c.useComma ? ',' : '.'; // decimal
      const parts = v.toFixed(2).split('.');
      let intp = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou); // separador de miles (1,790)
      let s = parts[1] === '00' ? intp : (intp + decSep + parts[1]);
      if (c.prefix || c.suffix) return (c.prefix || '') + s + (c.suffix || '');
      return s + (c.symbol || '$');
    };

    // Parte el título "Marca | Descripción" en pre (marca) + main, igual que las fichas cf-jcard
    const splitTitle = (t) => {
      t = String(t || '');
      let sep = '';
      if (t.indexOf(' | ') > -1) sep = ' | ';
      else if (t.indexOf('—') > -1) sep = '—';
      else if (t.indexOf('–') > -1) sep = '–';
      else if (t.indexOf(' - ') > -1) sep = ' - ';
      else if (t.indexOf('|') > -1) sep = '|';
      if (!sep) return { pre: '', main: t.trim() };
      const parts = t.split(sep);
      return { pre: (parts.shift() || '').trim(), main: parts.join(sep).trim() };
    };

    const renderCollection = (c) => `
      <a class="hj-search-coll" href="${escapeHTML(c.url)}">
        ${c.image?.src ? `<img src="${escapeHTML(c.image.src.replace(/\.(jpg|jpeg|png|webp)/i, '_120x120.$1'))}" alt="" loading="eager">` : '<span class="hj-search-coll-ph"></span>'}
        <span class="hj-search-coll-label">${escapeHTML(c.title)}</span>
      </a>
    `;
    const renderProduct = (p) => {
      const img = p.featured_image?.url || p.image || '';
      const price = p.price != null ? formatMoney(p.price) : '';
      // Comparar como NÚMEROS, no como strings ("1790.00" > "799.00" daba false por orden léxico)
      const cmpVal = parseFloat(p.compare_at_price_min);
      const curVal = parseFloat(p.price);
      const compare = (!isNaN(cmpVal) && !isNaN(curVal) && cmpVal > curVal) ? formatMoney(p.compare_at_price_min) : '';
      const t = splitTitle(p.title);
      return `
        <a class="hj-search-prod${compare ? ' hj-search-prod--sale' : ''}" href="${escapeHTML(p.url)}">
          ${img ? `<span class="hj-search-prod-imgwrap"><img src="${escapeHTML(img)}" alt="" loading="eager"></span>` : '<span class="hj-search-prod-imgwrap"></span>'}
          <span class="hj-search-prod-info">
            ${t.pre ? `<span class="hj-search-prod-pre">${escapeHTML(t.pre)}</span>` : ''}
            <span class="hj-search-prod-title">${escapeHTML(t.main)}</span>
            <span class="hj-search-prod-price">
              ${price ? `<span class="hj-search-prod-cur">${price}</span>` : ''}
              ${compare ? `<s>${compare}</s>` : ''}
            </span>
          </span>
          <span class="hj-search-prod-arrow" aria-hidden="true">→</span>
        </a>
      `;
    };

    const showState = (state) => {
      if (emptyState) emptyState.hidden = (state !== 'empty');
      if (content) content.hidden = (state !== 'content');
      if (noResults) noResults.hidden = (state !== 'noresults');
    };

    // === TABS ===
    const tabs = overlay.querySelectorAll('[data-hj-tab]');
    const panels = overlay.querySelectorAll('[data-hj-tab-panel]');
    const activateTab = (key) => {
      tabs.forEach(t => {
        const active = t.dataset.hjTab === key;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(p => { p.hidden = (p.dataset.hjTabPanel !== key); });
    };
    tabs.forEach(t => {
      t.addEventListener('click', (e) => {
        e.preventDefault();
        if (t.disabled) return;
        activateTab(t.dataset.hjTab);
      });
    });
    const syncTabs = (pCount, cCount) => {
      const tProducts = overlay.querySelector('[data-hj-tab="products"]');
      const tCollections = overlay.querySelector('[data-hj-tab="collections"]');
      if (tProducts) {
        tProducts.hidden = (pCount === 0);
        tProducts.disabled = (pCount === 0);
      }
      if (tCollections) {
        tCollections.hidden = (cCount === 0);
        tCollections.disabled = (cCount === 0);
      }
      // Choose default active tab: products if any, else collections
      if (pCount > 0) activateTab('products');
      else if (cCount > 0) activateTab('collections');
    };

    const fetchResults = (query) => {
      const reqId = ++lastReqId;
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last`;
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(r => r.json())
        .then(data => {
          if (reqId !== lastReqId) return; // outdated
          const products = data?.resources?.results?.products || [];
          const collections = data?.resources?.results?.collections || [];
          if (!products.length && !collections.length) {
            queryEl && (queryEl.textContent = query);
            showState('noresults');
            return;
          }
          if (collectionsEl) collectionsEl.innerHTML = collections.length ? `<div class="hj-search-coll-grid">${collections.slice(0,8).map(renderCollection).join('')}</div>` : '';
          if (productsEl) productsEl.innerHTML = products.length ? `<div class="hj-search-prod-list">${products.slice(0,8).map(renderProduct).join('')}</div>` : '';
          if (viewAllEl) viewAllEl.href = `/search?q=${encodeURIComponent(query)}&type=product`;
          // Update tab counts + visibility
          syncTabs(products.length, collections.length);
          showState('content');
        })
        .catch(() => {
          if (reqId !== lastReqId) return;
          showState('noresults');
        });
    };

    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(debounceTimer);
      if (!q) { showState('empty'); return; }
      debounceTimer = setTimeout(() => fetchResults(q), 200);
    });
    input.addEventListener('focus', () => {
      if (!input.value.trim()) showState('empty');
    });
    // Cerrar overlay con Esc
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') {
        overlay.setAttribute('aria-hidden','true');
        document.body.classList.remove('hj-search-open');
      }
    });
    // Initial state
    showState('empty');
  }

  function initMegaMenuPosition() {
    const hj = document.querySelector('.hj');
    if (!hj) return;
    const update = () => {
      const r = hj.getBoundingClientRect();
      // Top del mega menu = bottom del header completo (incluye nav row)
      document.documentElement.style.setProperty('--hj-mega-top', Math.max(0, r.bottom) + 'px');
    };
    update();
    window.addEventListener('resize', update);
    window.addEventListener('scroll', update, { passive: true });
    // También observar cambios de tamaño del header (e.g. al cambiar viewport)
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(hj);
    }
  }

  function initSlideshowSync() {
    document.querySelectorAll('slideshow-component').forEach((sc) => {
      const slider = sc.querySelector('.slider');
      const speedMs = (parseFloat(slider?.dataset?.speed) || 5) * 1000;
      const segments = sc.querySelectorAll('.slider-counter__link');
      const slides = sc.querySelectorAll('.slideshow__slide, .slider .grid__item');
      if (!segments.length || !slides.length) return;

      // Mark slideshow as initialized (CSS handles default visibility)
      sc.classList.add('ajb-initialized');

      // Neutralizar el update() nativo de Dawn (scroll/resize-based): compite con
      // nuestro temporizador propio y puede pisar las clases --active / aria-current
      // de los segmentos cada vez que el slider se redimensiona (p.ej. al cargar/cambiar
      // una imagen), rompiendo la barra de progreso.
      if (typeof sc.update === 'function') sc.update = function(){};

      let currentIdx = 0;

      const setActiveSlide = (idx) => {
        idx = ((idx % slides.length) + slides.length) % slides.length;
        currentIdx = idx;
        // CSS transitions handle entrance — solo togglemos la clase
        slides.forEach((s, i) => s.classList.toggle('ajb-active', i === idx));
        // Estado explícito por segmento (pasado/activo/futuro) — no depender de
        // selectores CSS de hermanos basados en posición en el DOM.
        segments.forEach((s, i) => {
          s.classList.remove('slider-counter__link--active', 'ajb-seg-future');
          if (i === idx) s.classList.add('slider-counter__link--active');
          else if (i > idx) s.classList.add('ajb-seg-future');
        });
        restartProgress();
      };

      // === PROGRESS BAR via requestAnimationFrame (lineal 0→100% en speedMs) ===
      let progressStart = 0;
      let progressRaf = null;
      const tickProgress = () => {
        const cur = segments[currentIdx];
        if (!cur) return;
        const elapsed = performance.now() - progressStart;
        const pct = Math.min(100, (elapsed / speedMs) * 100);
        cur.style.setProperty('--ajb-progress', pct + '%');
        if (pct < 100) progressRaf = requestAnimationFrame(tickProgress);
      };
      const restartProgress = () => {
        cancelAnimationFrame(progressRaf);
        segments.forEach(s => s.style.setProperty('--ajb-progress', '0%'));
        progressStart = performance.now();
        progressRaf = requestAnimationFrame(tickProgress);
      };

      // === AUTO-ROTATE via setInterval (controlado 100% por nosotros, no Dawn) ===
      let autoTimer = null;
      const startAuto = () => {
        clearInterval(autoTimer);
        autoTimer = setInterval(() => setActiveSlide(currentIdx + 1), speedMs);
      };
      const stopAuto = () => { clearInterval(autoTimer); cancelAnimationFrame(progressRaf); };

      sc.addEventListener('mouseenter', stopAuto);
      sc.addEventListener('mouseleave', () => { startAuto(); restartProgress(); });

      // === SWIPE táctil + drag desktop + TAP zonas izq/der (estilo Instagram Stories) ===
      const SWIPE_THRESHOLD = 50; // px mínimo para considerar swipe (resto = tap)
      const isInteractive = (el) => {
        // Detecta si el target es un botón/link (no interceptar)
        return el && el.closest && el.closest('a, button, .button, .slider-counter__link, [role="button"]');
      };
      let touchStartX = 0;
      let touchStartY = 0;
      let dragging = false;
      slider.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        dragging = true;
        stopAuto();
      }, { passive: true });
      slider.addEventListener('touchend', (e) => {
        if (!dragging) return;
        dragging = false;
        const dx = e.changedTouches[0].clientX - touchStartX;
        const dy = e.changedTouches[0].clientY - touchStartY;
        const absDx = Math.abs(dx), absDy = Math.abs(dy);
        if (absDx > SWIPE_THRESHOLD && absDx > absDy) {
          // SWIPE
          setActiveSlide(currentIdx + (dx < 0 ? 1 : -1));
        } else if (absDx < 10 && absDy < 10) {
          // TAP (sin movimiento) - solo si no es elemento interactivo
          if (!isInteractive(e.target)) {
            const rect = slider.getBoundingClientRect();
            const tapX = e.changedTouches[0].clientX - rect.left;
            setActiveSlide(currentIdx + (tapX < rect.width / 2 ? -1 : 1));
          }
        }
        startAuto();
      }, { passive: true });
      // Drag + click desktop
      let mouseStartX = 0;
      let mouseStartY = 0;
      let mouseDown = false;
      slider.addEventListener('mousedown', (e) => {
        mouseStartX = e.clientX;
        mouseStartY = e.clientY;
        mouseDown = true;
        stopAuto();
      });
      slider.addEventListener('mouseup', (e) => {
        if (!mouseDown) return;
        mouseDown = false;
        const dx = e.clientX - mouseStartX;
        const dy = e.clientY - mouseStartY;
        const absDx = Math.abs(dx), absDy = Math.abs(dy);
        if (absDx > SWIPE_THRESHOLD) {
          // DRAG
          setActiveSlide(currentIdx + (dx < 0 ? 1 : -1));
        } else if (absDx < 6 && absDy < 6) {
          // CLICK (sin drag) - solo si no es elemento interactivo
          if (!isInteractive(e.target)) {
            const rect = slider.getBoundingClientRect();
            const clickX = e.clientX - rect.left;
            setActiveSlide(currentIdx + (clickX < rect.width / 2 ? -1 : 1));
          }
        }
        startAuto();
      });
      slider.addEventListener('mouseleave', () => { mouseDown = false; });

      // Click en segmentos (Dawn ya lo hace, pero aseguramos)
      segments.forEach((seg, i) => {
        seg.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); setActiveSlide(i); }, true);
      });

      // Initial state + auto-start
      setActiveSlide(0);
      startAuto();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
